export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14086.36b761ed.jpg";